<template>
  <div>
    <div @click="editCropper()" title="点击上传图片">
      <el-upload
        :class="{'upload-files': true, 'upload-readonly': readOnly, 'hiddenBtnUplaod': (fileObjs.length >= limit && limit === 1)}"
        list-type="picture-card"
        action="#"
        :limit="limit"
        :disabled="true"
        :file-list="fileObjs">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img v-if="file.isImg && !readOnly" class="image" :src="file.url" alt="">
          <el-image
            v-if="file.isImg && readOnly"
            :src="file.url"
            class="image"
            fit="contain"
            :preview-src-list="[file.url]">
          </el-image>
          <div v-if="!file.isImg" class="doc">
            <i class="el-icon-document doc-icon"></i>
            <div class="doc-name">{{file.name}}</div>
          </div>
          <span class="el-upload-list__item-actions" v-if="file.isImg && !readOnly">
            <span class="el-upload-list__item-preview" @click.stop="handlePictureCardPreview(file)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
            <span class="el-upload-list__item-delete" @click.stop="handleEdit(file)" v-if="limit == 1">
              <i class="el-icon-edit"></i>
            </span>
          </span>
          <span class="el-upload-list__item-actions" v-if="!file.isImg">
            <span class="el-upload-list__item-delete" @click.stop="handleDownload(file)">
              <i class="el-icon-download"></i>
            </span>
            <span v-if="!readOnly" class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
        <div v-if="!readOnly" slot="tip" class="el-upload__tip">最多上传{{limit}}张图片</div>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
          <el-image
            :src="dialogImageUrl"
            style="height: 70vh;display:flex"
            fit="contain"
            :preview-src-list="[dialogImageUrl]">
          </el-image>
        </el-dialog>
      </el-upload>
    </div>
    <el-dialog title="上传图片" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false" @opened="modalOpened">
      <el-row :gutter="20">
        <el-col :xs="24" :md="12" :style="{height: '350px'}">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="option.info"
            :full="option.full"
            :fixedNumber="fixedNumber"
            :canScale="option.canScale"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed="option.fixed"
            :fixed-box="option.fixedBox"
            :auto-crop="option.autoCrop"
            :auto-crop-width="autoCropWidth"
            :auto-crop-height="autoCropHeight"
            :high="option.high"
            :info-true="option.infoTrue"
            :enlarge="option.enlarge"
            :mode="option.mode"
            :maxImgSize="option.maxImgSize"
            @realTime="realTime"
            v-if="open"
          />
        </el-col>
        <el-col :xs="24" :md="12" :style="{height: '350px'}">
          <div class="empty-box">
            <template v-if="!previews.url">请选择图片后预览哦</template>
          </div>
          <div class="upload-preview" :style="{width: previews.w+'px',height: previews.h+'px'}">
            <el-image
              :style="previews.img"
              :src="previews.url"
              fit="contain"></el-image>
          </div>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :lg="2" :md="2">
          <el-upload :accept="accept" action="#" :http-request="requestUpload" :show-file-list="false" :before-upload="beforeUpload">
            <el-button size="">
              上传
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
        </el-col>
        <el-col :lg="{span: 1, offset: 2}" :md="2">
          <el-button icon="el-icon-plus" size="" @click="changeScale(5)"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-minus" size="" @click="changeScale(-5)"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-left" size="" @click="rotateLeft()"></el-button>
        </el-col>
        <el-col :lg="{span: 1, offset: 1}" :md="2">
          <el-button icon="el-icon-refresh-right" size="" @click="rotateRight()"></el-button>
        </el-col>
        <el-col :lg="{span: 2, offset: 6}" :md="2">
          <el-button type="primary" size="" @click="uploadImg()">提 交</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
import { VueCropper } from "vue-cropper";
import { aliyunUpload } from '@/api/saas/package'
import UserAvatar from '@/views/system/user/userAvatar'

export default {
  components: { VueCropper, UserAvatar },
  props: {
    accept: {
      type: String
    },
    value: {},
    limit: {
      type: Number,
      default () {
        return 5
      }
    },
    fixedNumber: {
      type: Array,
      default() {
        return [3, 2]
      }
    },
    autoCropWidth: {
      type: Number,
      default: 200,
    },
    autoCropHeight: {
      type: Number,
      default: 150,
    },
    readOnly: {
      type: Boolean,
      default () {
        return false
      }
    },

  },
  watch: {
    value (val) {
      this.fileObjs = this.value || []
      this.option.img = ''
    }
  },
  data() {
    return {
      fileObjs:  this.value || [],
      uploadUrl: null,
      headers: {},
      addFilePopVisible: false,
      dialogImageUrl: '',
      dialogVisible: false,
      // 是否显示弹出层
      open: false,
      // 是否显示cropper
      visible: false,
      // 弹出层标题
      title: "修改头像",
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        full: true, // 是否输出原图比例的截图
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: this.autoCropWidth, // 默认生成截图框宽度
        autoCropHeight: this.autoCropHeight, // 默认生成截图框高度
        canMove: true, // 上传图片是否可以移动
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        height: true,
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: 'container', // 图片默认渲染方式
        maxImgSize: 2000, // 限制图片最大宽度和高度
        fixedNumber: this.fixedNumber
      },
      previews: {}
    };
  },
  mounted() {
    this.previews.w = this.autoCropWidth
    this.previews.h = this.autoCropHeight
  },
  methods: {
    handleEdit() {
      this.open = true;
    },
    // 编辑头像
    editCropper() {
      if(this.limit > this.fileObjs.length) {
        this.open = true;
      }else {
        this.msgWarning(`最多上传${this.limit}张图片`);
      }
    },
    // 打开弹出层结束时的回调
    modalOpened() {
      this.visible = true;
      console.log('option=', JSON.stringify(this.option))
    },
    // 覆盖默认的上传行为
    requestUpload() {
    },
    // 向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    // 上传预处理
    beforeUpload(file) {
      if (file.type.indexOf("image/") == -1) {
        this.msgError("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.option.img = reader.result;
        };
      }
    },
    // 上传图片
    uploadImg() {
      this.$refs.cropper.getCropBlob(data => {
        let formData = new FormData();
        formData.append("file", data);
        const loading = this.$loading({lock: true, text: '上传中', spinner: 'el-icon-loading'});
        aliyunUpload(formData).then(response => {
          this.open = false;
          // this.options.img = process.env.VUE_APP_BASE_API + response.imgUrl;
          // 修改头像返回url
          this.option.img = response.imgUrl;
          this.msgSuccess("成功");
          if(this.limit === 1) {
            this.fileObjs = [{
              id: response.id,
              isImg: response.isImg,
              name: response.name,
              url: response.url,
              size: response.size,
              contentType: response.contentType
            }]
          }else {
            this.fileObjs.push({
              id: response.id,
              isImg: response.isImg,
              name: response.name,
              url: response.url,
              size: response.size,
              contentType: response.contentType
            })
          }
          // this.fileObjs = response
          this.$emit('input', this.fileObjs)
          this.$emit('on-change', this.fileObjs)
          this.visible = false;
        }).finally(()=>loading.close());
      });
    },
    // 实时预览
    realTime(data) {
      this.previews = data;
      // this.option.autoCropHeight = this.previews.h
      // this.option.autoCropWidth = this.previews.w
    },
    handleRemove(file, fileList) {
      for (let i = 0; i < this.fileObjs.length; i++) {
        if (this.fileObjs[i].url === file.url) {
          this.fileObjs.splice(i, 1);
          i--;
        }
      }
      this.$emit('input', this.fileObjs)
      this.$emit('on-change', this.fileObjs)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  }
};
</script>
<style lang="scss">
.upload-preview{
  position: absolute;
	top: 50%;
	transform: translate(0, -50%);
	// width: 200px;
	// height: 150px;
	// border-radius: 50%;
	box-shadow: 0 0 4px #ccc;
  overflow: hidden;
}
.empty-box{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #888;
  line-height: 350px;
  text-align: center;
  background: #f7f7f7;
}
.hiddenBtnUplaod .el-upload--picture-card{
  display: none;
}
</style>
